// removed by extract-text-webpack-plugin
module.exports = {"flexPrev":"_3igmJb33iGhYSXWMkyvmNR","flexNext":"_51xQVVR53YUBwg1Fza-G1","flexFirst":"etRSjxU-fYkCGfLVmA-d_","carousel":"_3SSRbd3wsIW34ROL8yXHT5","dotsClass":"_2wEsVbFJ42p4qYyUsAOr70","slick-active":"zqdvkE0OXm4mvaHRvCDsy","dotsIntroClass":"rEcDWgEnRpho6NSUITa6W","singleImg":"_3CPkdtyyqF3mVpxsNb0eKA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ProductInfoFirstCarousel/ProductInfoFirstCarousel.scss
 ** module id = 263
 ** module chunks = 0
 **/